'use client'

import React, { createContext, useContext, useMemo, useState } from 'react'

export type AdminBarCollectionSlug = 'pages' | 'posts' | 'categories' | 'tags'

export type AdminBarDocument = {
  collectionSlug: AdminBarCollectionSlug
  id: string | number
} | null

type Ctx = {
  doc: AdminBarDocument
  setDoc: (doc: AdminBarDocument) => void
}

const AdminBarDocumentContext = createContext<Ctx | null>(null)

export function AdminBarDocumentProvider({ children }: { children: React.ReactNode }) {
  const [doc, setDoc] = useState<AdminBarDocument>(null)
  const value = useMemo(() => ({ doc, setDoc }), [doc])
  return <AdminBarDocumentContext.Provider value={value}>{children}</AdminBarDocumentContext.Provider>
}

export function useAdminBarDocument(): Ctx {
  const c = useContext(AdminBarDocumentContext)
  if (!c) {
    throw new Error('useAdminBarDocument must be used within AdminBarDocumentProvider')
  }
  return c
}

/**
 * Regista na barra de admin o documento Payload em edição (rota actual).
 * Limpa ao desmontar para não manter links incorrectos entre navegações.
 */
export function RegisterAdminBarDoc({
  collectionSlug,
  id,
}: {
  collectionSlug: AdminBarCollectionSlug
  id: string | number
}) {
  const { setDoc } = useAdminBarDocument()

  React.useEffect(() => {
    setDoc({ collectionSlug, id })
    return () => setDoc(null)
  }, [collectionSlug, id, setDoc])

  return null
}
